export default __webpack_public_path__ + "static/media/komi.07412b05.yaml";